import { useSelector } from "react-redux";
import { AppState } from "../../../core/app/AppReducer";
import OcarinaOfTime from "../../../core/assets/oot/gshd/ocarina-of-time_32x32.png";
import FairyOcarina from "../../../core/assets/oot/gshd/ocarina_32x32.png";
import UpgradeItem from "../../../core/items/UpgradeItem";
import OotItem from "./OotItem";
import EmptyItem from "./EmptyItem";
import { SimpleItemProps } from "./SimpleItemProps";
import StaticItem from "../../../core/items/StaticItem";

const id = "OoT_Ocarina"

const OcarinaItem = () => {


    let reduce = useSelector((state: AppState) => state.ui.ootr.main.useItemTrackerReduce)
    let shuffle = useSelector((state: AppState) => state.ui.ootr.main.ocarinaShuffle)

    if (reduce && !shuffle)
        return <EmptyItem />;

    return <OotItem id={id}>
        {({ updateOotItem, item }) => {

            return <UpgradeItem id={id} image={[FairyOcarina, OcarinaOfTime]} title={["Fairy Ocarina", "Ocarina Of Time"]}
                upgradeLabel={["", ""]}
                updateItem={updateOotItem}
                item={item}
                isMajor
            />

        }}</OotItem>
}

export default OcarinaItem;

export const SimpleOcarinaItem = (props: SimpleItemProps) => {


    return <StaticItem
        image={FairyOcarina}
        onClick={props.onClick}
        name={id}
    />




}